module.exports = __webpack_public_path__ + "img/user_icon.852d74fa.svg";